module.exports = __webpack_public_path__ + "img/node.7bf5f494.png";